import {
  Input as BaseInput,
  InputAddon,
  InputWrapper
} from '@/components/ui/input'

// import { cn } from '@/lib';
import { cn, isFieldInvalid } from '@/utils'

import { FieldWrapper } from './field-wrapper'
import { useFieldContext } from './form'

export type InputProps = {
  endAddon?: React.ReactNode
  endAddonClassName?: string
  label?: string
  labelClassName?: string
  labelTooltip?: string
  ref?: React.Ref<HTMLInputElement>
  required?: boolean
  startAddon?: React.ReactNode
  startAddonClassName?: string
  wrapperClassName?: string
} & React.ComponentProps<typeof BaseInput>

export const Input = (props: InputProps) => {
  const field = useFieldContext<string>()
  const isInvalid = isFieldInvalid(field)
  const {
    className,
    endAddon,
    endAddonClassName,
    label,
    labelClassName,
    labelTooltip,
    required,
    startAddon,
    startAddonClassName,
    variant,
    wrapperClassName,
    ...inputProps
  } = props

  return (
    <FieldWrapper
      classNames={{
        label: labelClassName,
        wrapper: wrapperClassName
      }}
      field={field}
      label={label}
      labelTooltip={labelTooltip}
      required={required}
    >
      <InputWrapper
        className="h-[42px] rounded-md !px-3.5 !py-2"
        data-invalid={isInvalid || undefined}
      >
        {startAddon ? (
          <InputAddon
            className={cn(
              startAddonClassName,
              'bg-background border-none shadow-none'
            )}
            variant={variant}
          >
            {startAddon}
          </InputAddon>
        ) : null}
        <BaseInput
          aria-invalid={isInvalid || undefined}
          autoComplete="off"
          className={cn(className, 'rounded-none')}
          id={field.name}
          name={field.name}
          onBlur={field.handleBlur}
          onChange={(e) => {
            field.handleChange(e.target.value)
          }}
          value={field.state.value ?? ''}
          {...inputProps}
        />
        {endAddon ? (
          <InputAddon
            className={cn(
              endAddonClassName,
              'bg-background border-none shadow-none'
            )}
            variant={variant}
          >
            {endAddon}
          </InputAddon>
        ) : null}
      </InputWrapper>
    </FieldWrapper>
  )
}
